import React from 'react';
import Link from '@components/ui-old/link';
import { NextSeo } from 'next-seo';
import Carousel from '@components/ui-old/carousel/carousel';
import { SwiperSlide } from 'swiper/react';
import { useTranslation } from 'next-i18next';
import { useWindowSize } from '@utils/use-window-size';
import { useSsrCompatible } from '@utils/use-ssr-compatible';
import { siteSettings } from '@settings/site-settings';
import Button from '@components/ui-old/button';
import { getThemedImage } from '@components/layout/get-themed-image';
const productGalleryCarouselResponsive = {
  '1024': {
    slidesPerView: 1
  },
  '768': {
    slidesPerView: 1
  },
  '0': {
    slidesPerView: 1
  }
};
const ProductNotFound: React.FC = () => {
  const {
    t
  } = useTranslation('common');
  const {
    width
  } = useSsrCompatible(useWindowSize(), {
    width: 0,
    height: 0
  });
  const notFoundImageLight = '/assets/placeholder/products/product-cat.svg';
  const notFoundImageDark = '/assets/placeholder/products/product-cat-dark.svg';
  return <>
      <NextSeo title={`${t('text-product-not-found')} | ${siteSettings.name}`} description={t('text-product-not-found-description')} canonical={`${siteSettings.author.websiteUrl}shop/product-not-found`} data-sentry-element="NextSeo" data-sentry-source-file="product-not-found.tsx" />
      <div className="block lg:grid grid-cols-9 pt-7 pb-10 lg:pb-14 2xl:pb-20 items-start px-4 md:px-6 lg:px-8 max-w-8xl mx-auto">
        {width < 1025 ? <div className="col-span-9">
            <Carousel pagination={{
          clickable: true
        }} breakpoints={productGalleryCarouselResponsive} className="product-gallery" buttonGroupClassName="hidden">
              <SwiperSlide key="product-not-found-slide">
                <div className="transition duration-150 ease-in hover:opacity-90">
                  {getThemedImage(notFoundImageLight, notFoundImageDark, t('text-product-not-found'), {
                width: 600,
                height: 600,
                className: 'object-cover w-full'
              })}
                </div>
              </SwiperSlide>
            </Carousel>
          </div> : <div className="col-span-5 grid grid-cols-1 gap-2.5 2xl:max-w-[600px] 2xl:mr-[250px] xl:max-w-[550px] xl:mr-[130px] lg:max-w-[500px] lg:mr-[100px] mx-auto">
          <div className="transition duration-150 ease-in hover:opacity-90">
              <Carousel pagination={{
            clickable: true
          }} breakpoints={productGalleryCarouselResponsive} className="product-gallery" buttonGroupClassName="hidden">
                <SwiperSlide key="product-not-found-slide">
                  <div className="transition duration-150 ease-in hover:opacity-90">
                    {getThemedImage(notFoundImageLight, notFoundImageDark, t('text-product-not-found'), {
                  width: 600,
                  height: 600,
                  className: 'object-cover w-full'
                })}
                  </div>
                </SwiperSlide>
              </Carousel>
            </div>
          </div>}
        <div className="col-span-4 pt-8 lg:pt-0 flex flex-col justify-center">
          <h1 className="text-heading dark:text-neutral-200 text-lg md:text-xl lg:text-2xl 2xl:text-3xl font-bold mb-3.5">
            {t('text-product-not-found')}
          </h1>
          <p className="text-body text-l lg:text-base leading-6 lg:leading-8 my-6">
            {t('text-product-not-found-description')}
          </p>
          <Link href="/e-shop" data-sentry-element="Link" data-sentry-source-file="product-not-found.tsx">
            <Button variant="slim" className="w-full md:w-6/12 xl:w-full mt-12" data-sentry-element="Button" data-sentry-source-file="product-not-found.tsx">
                <span className="py-2 3xl:px-8">{t('back-to-shop')}</span>
            </Button>
         </Link>
        </div>
      </div>
    </>;
};
export default ProductNotFound;